import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {Title} from '@angular/platform-browser';

@Component({
  selector: 'app-sitemap',
  templateUrl: './sitemap.component.html',
  styleUrls: ['./sitemap.component.scss'],
  encapsulation: ViewEncapsulation.Emulated
})
export class SitemapComponent implements OnInit {

  constructor(private titleService: Title) {
      this.titleService.setTitle('Alexander Koenig - Sitemap');
  }

  ngOnInit() {
  }

}
